import { z } from 'zod';
import { platformModuleIdSchema } from '../modules/platform-module-manifest.contract.js';
export const platformJsonValueSchema = z.lazy(() => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(platformJsonValueSchema),
    z.record(z.string(), platformJsonValueSchema),
]));
export const platformSettingDefinitionSchema = z.strictObject({
    key: z.string().regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+){2,}$/),
    moduleId: platformModuleIdSchema,
    title: z.string().min(1).max(120),
    helpText: z.string().min(1).max(500),
    configurationDomain: z.enum(['theme', 'layout', 'copy', 'module', 'branding', 'accessibility']),
    valueType: z.enum(['string', 'number', 'boolean', 'enum', 'object', 'array']),
    schemaVersion: z.number().int().positive(),
    codedFallback: platformJsonValueSchema,
    permittedScopes: z.array(z.enum(['platform', 'plan', 'tenant', 'user', 'device'])).min(1),
    mergeStrategy: z.enum(['replace', 'deep-merge']),
    clientSafe: z.boolean(),
    serverOnly: z.boolean(),
    sensitive: z.boolean(),
    tenantEditable: z.boolean(),
    userOverridable: z.boolean(),
    offlineEligible: z.boolean(),
    safetyClass: z.enum(['ordinary', 'protected', 'operational-reference']),
});
//# sourceMappingURL=platform-setting-definition.contract.js.map